import React from 'react';
import DfbSymbol from '../../ui-kit/dfb_symbol';
import { categoryIconMapping, getCategoryIconType } from "../../utilities"

function buildCategoryIcons(categories) {
  if (categories && categories.length > 0) {
    const iconTypes = categories.map((item) => getCategoryIconType(item))
      .filter(itemType => itemType && categoryIconMapping(itemType) !== false )
    return iconTypes.map(iconType => (
      <div className="dfb-Card-icon" key={iconType}>
        <DfbSymbol icon_type={iconType} />
      </div>
    ))
  } else {
    return null
  }
}

const DfbCardIcons = (props) => {
  const icons = buildCategoryIcons(props.data.content.root_categories)
  if (icons && icons.length > 0) {
    return (<div className="dfb-Card-icons">
      {icons}
    </div>)
  } else {
    return null
  }
}

export default DfbCardIcons;
